jQuery(document).ready(function () {
  $('.variant-description-wrapper').eq(0).show();

  if (jQuery("free-shipping-bar.shipping-bar").css("--progress") == "1") {
    jQuery("span.shipping-bar__progress").css("border-color", "#45ba13");
    jQuery("free-shipping-bar.shipping-bar .shipping-bar__progress").addClass(
      "bar_custom"
    );
  } else {
    jQuery(
      "free-shipping-bar.shipping-bar .shipping-bar__progress"
    ).removeClass("bar_custom");
  }



    $('#fixed-bar-cart select').change(function() {
      var value = this.value;
      var optionName = $(this).find(':selected').attr('name');
      var valueSelected = $(this).find(':selected').val();
      console.log('optionName---'+optionName+'---valueSelected = '+valueSelected);
      jQuery('.variant-wrapper.js fieldset[name="'+optionName+'"] input[value="'+valueSelected+'"]').click();
       updateFixedBar();
    });

    jQuery('.variant-input-wrap .variant-input :radio').change(function() {
       var ValSelected = $(this).val();
       var OpName = $(this).attr('name');
       $('#fixed-bar-cart select[name="'+OpName+'"]').val(ValSelected).change();
      
    });

  

    $("#fixed-bar-cart #fixed-bar-add").click(function(){
      $('.namture-product-info button.add-to-cart').first().trigger('click');
    });


  
});

var updateFixedBar = function() {
  var source = document.querySelector('.namture-product-info');
  var bar = document.getElementById('fixed-bar-cart');
  if (!source || !bar) return;
  var price = source.querySelector('.namture-current-price') || source.querySelector('[data-product-price]');
  var button = source.querySelector('button.add-to-cart');
  if (price) {
    var priceCopy = price.cloneNode(true);
    priceCopy.removeAttribute('data-product-price');
    priceCopy.querySelectorAll('[data-product-price]').forEach(function(el) {
      el.removeAttribute('data-product-price');
    });
    var compare = source.querySelector('[data-compare-price]');
    var compareWrap = compare && compare.closest('[data-product-price-wrap]');
    var priceTarget = bar.querySelector('#fixed-bar-price');
    if (compare && compare.textContent.trim() && !compare.hidden && (!compareWrap || (!compareWrap.hidden && !compareWrap.classList.contains('hide')))) {
      var compareCopy = document.createElement('s');
      compareCopy.className = 'namture-sticky-compare';
      compareCopy.textContent = compare.textContent.trim();
      priceTarget.replaceChildren(compareCopy, priceCopy);
    } else {
      priceTarget.replaceChildren(priceCopy);
    }
  }
  if (button) {
    var stickyButton = bar.querySelector('#fixed-bar-add');
    stickyButton.innerHTML = button.innerHTML;
    stickyButton.disabled = button.disabled;
    stickyButton.classList.toggle('btn--loading', button.classList.contains('btn--loading'));
  }
};

jQuery(function() {
  var source = document.querySelector('.namture-product-info');
  if (!source) return;
  var observer = new MutationObserver(updateFixedBar);
  var price = source.querySelector('.product-block--price');
  var button = source.querySelector('button.add-to-cart');
  if (price) observer.observe(price, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden'] });
  if (button) observer.observe(button, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
  updateFixedBar();
});


jQuery(window).load(function () {
  if (jQuery("free-shipping-bar.shipping-bar").css("--progress") == "1") {
    jQuery("span.shipping-bar__progress").css("border-color", "#45ba13");
    jQuery("free-shipping-bar.shipping-bar .shipping-bar__progress").addClass(
      "bar_custom"
    );
  } else {
    jQuery(
      "free-shipping-bar.shipping-bar .shipping-bar__progress"
    ).removeClass("bar_custom");
  }


   updateFixedBar();
  
});

  jQuery(document).on("click", '.cart__remove a', function(e) {
    e.preventDefault();
    jQuery(this).closest('.cart__item-sub').find('.js-qty__num').val('0');

    var variant_id = jQuery(this).attr('data-id');
     console.log(variant_id);
    var obj = {};
    obj[variant_id]= 0;
    removem_data = { updates: obj };
    jQuery.ajax({
        url: "/cart/update.js",
        type: "POST",
        data: JSON.stringify(removem_data), 
        contentType: "application/json",
        dataType: 'json',
        success: function(responce) {
          // console.log('removed');
		  //$('.cart__item[data-id="'+variant_id+'"]').remove();
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:build'));

        }            
      });
  }); 


$(window).on('scroll resize load', function() {
  var button = document.querySelector('.namture-product-info button.add-to-cart');
  var bar = document.getElementById('fixed-bar-cart');
  if (button && bar) {
    bar.classList.toggle('active', button.getBoundingClientRect().bottom <= 0);
  }
});


var position = $(window).scrollTop(); 
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if(scroll > position) {
        $('#SiteHeader').addClass('scrolling-down').removeClass('scrolling-up');
        $('.announcement-bar').addClass('scrolling-down').removeClass('scrolling-up');
    } else {
        $('#SiteHeader').removeClass('scrolling-down').addClass('scrolling-up');
        $('.announcement-bar').removeClass('scrolling-down').addClass('scrolling-up');
    }
    if(scroll > 250){
      $('.announcement-bar').addClass('sticky');
    }else{
      $('.announcement-bar').removeClass('sticky');
    }
    position = scroll;
});


document.addEventListener('variant:change', function(evt) {
  console.log(evt.detail.variant);
  var variant = evt.detail.variant;
  // Update variant description
  if($('.variant-description-wrapper').length > 0){
    $('.variant-description-wrapper .variant-description').hide();
    $('.variant-description-wrapper .variant-description.variant-description-'+variant.id).show();
    var variant_title = $('.variant-description-wrapper .variant-title.variant-title-'+variant.id).val();
    if(variant_title != ''){
      $('h1.product-single__title').text(variant_title);
    }
  }

  // Update product content for snijplank
  $('.product-content-snijplank').removeClass('active');
  if(variant.title.indexOf("Acacia") != -1 && variant.title.indexOf("Set") != -1){
    $('.product-content-acacia-set').addClass('active');
  }else if (variant.title.indexOf("Acacia") != -1  && variant.title.indexOf("XL") != -1){
    $('.product-content-acacia-xl').addClass('active');
  }else if (variant.title.indexOf("Acacia") != -1  && variant.title.indexOf("L") != -1){
    $('.product-content-acacia-l').addClass('active');
  }else if (variant.title.indexOf("Acacia") != -1  && variant.title.indexOf("M") != -1){
    $('.product-content-acacia-m').addClass('active');
  }else if (variant.title.indexOf("Bamboe") != -1 && variant.title.indexOf("Set") != -1){
    $('.product-content-bamboe-set').addClass('active');
  }else if (variant.title.indexOf("Bamboe") != -1){
    $('.product-content-bamboe-m').addClass('active');
  }

  // Update product link snijplank
  var urlRedirect = $('.snijplank-product-'+variant.id).val();
  if(urlRedirect){
    $('#snijplank-link').attr('href',urlRedirect);
  }

  // Update product content for hakblok
  $('.product-content-hakblok').removeClass('active');
  if(variant.title.indexOf("Acacia") != -1 && variant.title.indexOf("Classic") != -1){
    $('.product-content-acacia-classic').addClass('active');
  }else if (variant.title.indexOf("Acacia") != -1  && variant.title.indexOf("Sharp") != -1){
    $('.product-content-acacia-sharp').addClass('active');
  }else if (variant.title.indexOf("Bamboe") != -1  && variant.title.indexOf("Classic") != -1){
    $('.product-content-bamboe-classic').addClass('active');
  }else if (variant.title.indexOf("Bamboe") != -1  && variant.title.indexOf("Sharp") != -1){
    $('.product-content-bamboe-sharp').addClass('active');
  }

  // Update product link hakblok
  var urlRedirect = $('.hakblok-product-'+variant.id).val();
  if(urlRedirect){
    $('#hakblok-link').attr('href',urlRedirect);
  }

  // Handle custom id for product listings snijplank/hakblok
  var customId = $('.variant-item-'+variant.id).data('id');
  $('#custom-id').val(customId);
  var customAvailable = $('.variant-item-'+variant.id).data('available');
  if(customAvailable){
    var customBtnText = $('.variant-item-'+variant.id).data('atc-text');
    $('.custom-atc').text(customBtnText).removeAttr('disabled');
  }else{
    var customBtnText = $('.variant-item-'+variant.id).data('soldout-text');
    $('.custom-atc').text(customBtnText).attr('disabled','disabled');
  }
  
});

function productATC(){
  document.querySelector('a.custom-atc').classList.add('btn--loading');
  const variantID = document.querySelector('#custom-id').value;
  console.log(variantID);
  let formData = {
  'items': [{
    'id': variantID,
    'quantity': Math.max(1, parseInt(document.querySelector('a.custom-atc').closest('form').querySelector('[name="quantity"]').value, 10) || 1)
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    //return response.json();
    document.querySelector('a.custom-atc').classList.remove('btn--loading');
    document.dispatchEvent(new CustomEvent('cart:build'));
    setTimeout(function() {
      document.querySelector('.js-drawer-open-cart').click();
    }, 700);
    
  })
  .catch((error) => {
    console.error('Error:', error);
  });
    
}

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
(function () {
  function initShippingAppearance() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.dataset.shippingAppearanceReady) return;
    drawer.dataset.shippingAppearanceReady = 'true';
    function update() {
      drawer.querySelectorAll('free-shipping-bar').forEach(function (bar) {
        var progress = parseFloat(bar.style.getPropertyValue('--progress'));
        var complete = Number.isFinite(progress) && progress >= 1;
        var state = complete ? 'true' : 'false';
        if (bar.dataset.shippingComplete !== state) bar.dataset.shippingComplete = state;
        var label = bar.querySelector('.shipping-bar__text');
        var message = document.documentElement.lang.indexOf('en') === 0
          ? 'Your order ships for free.' : 'Je bestelling wordt gratis verzonden';
        if (!complete && Number.isFinite(progress)) {
          var threshold = Number(bar.getAttribute('threshold'));
          var remaining = Math.max(0, Math.round(threshold * (1 - progress))) / 100;
          var english = document.documentElement.lang.indexOf('en') === 0;
          var amount = theme.Currency.formatMoney(Math.round(remaining * 100), theme.settings.cartMoneyFormat).replace(/<[^>]*>/g, '');
          message = english ? amount + ' away from free shipping' : 'Nog ' + amount + ' tot gratis verzending';
        }
        if (label && Number.isFinite(progress) && label.textContent !== message) label.textContent = message;
      });
      drawer.querySelectorAll('[data-shipping]').forEach(function (price) {
        var clean = price.textContent.replace(/€/g, '').trim();
        if (/^\d+(?:[.,]\d{1,2})?$/.test(clean)) {
          var cents = Math.round(Number(clean.replace(',', '.')) * 100);
          var formatted = theme.Currency.formatMoney(cents, theme.settings.cartMoneyFormat).replace(/<[^>]*>/g, '');
          if (price.textContent !== formatted) price.textContent = formatted;
        }
      });
    }
    update();
    new MutationObserver(update).observe(drawer, {
      subtree: true, childList: true, characterData: true,
      attributes: true, attributeFilter: ['style']
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShippingAppearance);
  else initShippingAppearance();
  document.addEventListener('shopify:section:load', initShippingAppearance);
})();


(function () {
  function bindCartReferencePrices() {
    document.querySelectorAll('form [data-discounts]').forEach(function (discounts) {
      if (discounts.dataset.namtureReferenceBound) return;
      discounts.dataset.namtureReferenceBound = 'true';
      var form = discounts.closest('form');
      function syncReferencePrice() {
        var source = discounts.querySelector('[data-namture-cart-reference]');
        var target = form.querySelector('.namture-cart-compare');
        if (!target) return;
        var price = source ? source.dataset.namtureCartReference : '';
        target.textContent = price;
        target.hidden = !price;
        var inlineSavings = form.querySelector('[data-namture-inline-savings]');
        if (inlineSavings) {
          var badge = inlineSavings.querySelector('.namture-cart-savings');
          var label = badge && badge.querySelector('span');
          var sourceLabel = source && source.querySelector('span');
          if (label) label.textContent = sourceLabel ? sourceLabel.textContent : '';
          if (badge) badge.hidden = !price;
        }
      }
      new MutationObserver(syncReferencePrice).observe(discounts, {childList:true,subtree:true});
      syncReferencePrice();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindCartReferencePrices);
  else bindCartReferencePrices();
  document.addEventListener('shopify:section:load', bindCartReferencePrices);
})();

(function () {
  function initCareOffer() {
    var drawer = document.getElementById('CartDrawer');
    var offer = drawer && drawer.querySelector('[data-care-offer]');
    var products = drawer && drawer.querySelector('[data-products]');
    if (!offer || !products || offer.dataset.bound) return;
    offer.dataset.bound = 'true';
    function update() {
      var links = Array.from(products.querySelectorAll('a[href]')).map(function (a) { return a.getAttribute('href'); });
      var board = links.some(function (url) { var handle = url.split('/products/')[1]; return handle && ["snijplankenset-acacia","snijplankenset-bamboe","snijplank-bamboe-medium","snijplank-bamboe-large","snijplank-bamboe-extra-large","snijplank-acacia-medium","snijplank-acacia-large","snijplank-acacia-extra-large","hablok-acacia-sharp","hakblok-acacia-classic","hakblok-bamboe-sharp","hakblok-bamboe-classic","pizza-board","tapas-board"].indexOf(handle.split(/[?#/]/)[0]) !== -1; });
      var care = links.some(function (url) { return url.indexOf('/products/onderhoudsetje') !== -1; });
      offer.hidden = !board || care;
    }
    new MutationObserver(update).observe(products, {childList:true,subtree:true});
    update();
    offer.querySelector('[data-care-add]').addEventListener('click', async function () {
      var button = this;
      if (button.disabled) return;
      button.disabled = true;
      var error = offer.querySelector('.namture-care__error');
      error.hidden = true;
      try {
        var root = window.Shopify.routes.root;
        var response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(offer.dataset.careId),quantity:1,properties:offer.dataset.carePreorder==="true"?{_namture_preorder:"1","Pre-order":offer.dataset.careDispatch||"Pre-order"}:{}}]})});
        if (!response.ok) throw new Error('Cart add failed');
        document.dispatchEvent(new CustomEvent('cart:build'));
      } catch (e) {error.hidden = false;}
      finally {button.disabled = false;}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCareOffer);
  else initCareOffer();
  document.addEventListener('shopify:section:load', initCareOffer);
})();

